import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import Search from '@/components/SearchV3/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import { format, subDays } from 'date-fns';
import { downloadWithNewWindow } from '@/common/download';
import { v2Host } from '@/config/host';
import qs from 'qs';
import { parseTime } from '@/filters/index';
import { cookRequestParams } from '@/common/request';
import tableMixin from './table-mixin';
import { getPlayableProjectList } from '@/api/dashboard/playturbo.js';
import { GrantTypeLabelOptions, GrantTypeLabel } from '@/common/permission';
import { formatTimeWithoutMs } from '@com/utils/data-format';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { statusOptions, templateTypeOptions } from '@/common/permission';
import { projectCreatedPageOptions } from '@/config/project';

var dayTime = 1000 * 60 * 60 * 24;

var psWidgetOptions = [{
  label: '连线',
  value: 'drawLine'
}, {
  label: '自由画线',
  value: 'freeDrawLine'
}, {
  label: '擦除',
  value: 'erase'
}, {
  label: '遮罩',
  value: 'mask'
}, {
  label: '轮播',
  value: 'carousel'
}, {
  label: '棋盘',
  value: 'ps.GridView'
}, {
  label: '停车解谜',
  value: 'ps.ParkComponent'
}, {
  label: '拼图',
  value: 'ps.PuzzleComponent'
}];

var playableProjectTypeOptions = [{
  label: '定制',
  value: 'dm'
}, {
  label: '可玩编辑',
  value: 'gm'
}, {
  label: '自由编辑',
  value: 'ps'
}];

var defaultQuery = {
  page: 1,
  page_size: 50,
  time: [format(subDays(new Date() - dayTime * 30, 1), 'YYYY-MM-DD'), format(subDays(new Date(), 1), 'YYYY-MM-DD')],
  adv_ids: [],
  adv_id: '',
  template_types: [],
  adv_search_type: 'adv_name',
  project_name: '',
  project_ids: '',
  skin_name: '',
  project_types: [],
  grant_types: [],
  created_pages: [],
  template_name: '',
  template_ids: '',
  export: 0
};

export default {
  mixins: [searchMixin, tableMixin],

  components: {
    Search: Search,
    TableList: TableList,
    Pagination: Pagination
  },
  data: function data() {
    return {
      query: _extends({}, defaultQuery),

      list: [],
      listLoading: false,

      tableConfig: {
        'row-key': '_id'
      },

      pagination: {
        total: 0
      }
    };
  },


  computed: {
    formItemList: function formItemList() {
      var list = {
        time: {
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'time',
          class: 'date-picker',
          params: {
            clearable: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            startPlaceholder: '创建开始时间',
            endPlaceholder: '创建结束时间',
            pickerOptions: {
              disabledDate: function disabledDate(time) {
                return time.getTime() > Date.now();
              },

              shortcuts: [{
                text: '最近三天',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: this.$t('form.pastWeek'),
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近半个月',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                  picker.$emit('pick', [start, end]);
                }
              }]
            }
          }
        },
        adv_search_type: {
          type: 'select',
          prop: 'adv_search_type',
          params: {
            options: [{
              label: '广告主名称',
              value: 'adv_name'
            }, {
              label: '广告主ID',
              value: 'adv_id'
            }]
          }
        },
        adv_ids: {
          prop: 'adv_ids',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            multiple: true,
            filterable: true,
            collapseTags: true,
            class: 'search-filter-select'
          }
        },
        adv_id: {
          type: 'input',
          prop: 'adv_id',
          params: {
            clearable: true,
            placeholder: '请输入广告主ID'
          }
        },
        // template_search_type: {
        //   type: 'select',
        //   prop: 'template_search_type',
        //   params: {
        //     options: [
        //       {
        //         label: '模板名称',
        //         value: 'template_name',
        //       },
        //       {
        //         label: '模板id',
        //         value: 'template_ids',
        //       },
        //     ],
        //   },
        // },
        template_name: {
          type: 'input',
          prop: 'template_name',
          params: {
            clearable: true,
            placeholder: '请输入模板名称'
          }
        },
        template_ids: {
          type: 'input',
          prop: 'template_ids',
          params: {
            clearable: true,
            placeholder: '请输入模板id'
          }
        },
        template_types: {
          type: 'select',
          prop: 'template_types',
          params: {
            clearable: true,
            placeholder: '请选择模板类型',
            options: templateTypeOptions
          }
        },
        skin_name: {
          type: 'input',
          prop: 'skin_name',
          params: {
            clearable: true,
            placeholder: '请输入皮肤名称'
          }
        },
        project_types: {
          type: 'select',
          prop: 'project_types',
          params: {
            clearable: true,
            options: playableProjectTypeOptions,
            placeholder: '请选择项目类型'
          }
        },
        project_name: {
          type: 'input',
          prop: 'project_name',
          params: {
            clearable: true,
            placeholder: '请输入项目名称'
          }
        },
        project_ids: {
          type: 'input',
          prop: 'project_ids',
          params: {
            clearable: true,
            placeholder: '请输入项目id'
          }
        },
        grant_types: {
          type: 'select',
          prop: 'grant_types',
          params: {
            clearable: true,
            placeholder: '请选择订阅类型',
            options: GrantTypeLabelOptions
          }
        },
        created_pages: {
          type: 'select',
          prop: 'created_pages',
          params: {
            placeholder: '请选择项目创建页面',
            clearable: true,
            options: projectCreatedPageOptions
          }
        }
        // 广告主/id
      };if (this.query.adv_search_type === 'adv_name') {
        delete list.adv_id;
      } else {
        delete list.adv_ids;
      }
      return list;
    },
    tableColumnConfig: function tableColumnConfig() {
      var tableList = [{
        label: '项目创建时间',
        prop: 'created_time',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            return parseTime(row.created_time, '{y}-{m}-{d}');
          }
        }
      }, {
        label: '订阅类型',
        prop: 'plan_grant_type',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            return GrantTypeLabel[row.plan_grant_type];
          }
        }
      }, {
        label: '状态',
        prop: 'plan_status',
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            return statusOptions[row.plan_status] || row.plan_status;
          }
        }
      }, {
        label: '广告主Id',
        prop: 'adv_id'
      }, {
        label: '广告主名称',
        prop: 'adv_name'
      }, {
        label: '创建页面',
        prop: 'created_page',
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            return useValueExchangeLabel(row.created_page, projectCreatedPageOptions);
          }
        }
      }, {
        label: '模板类型',
        prop: 'template_type',
        params: {
          innerHTML: function innerHTML(_ref5) {
            var row = _ref5.row;

            return useValueExchangeLabel(row.template_type, templateTypeOptions) || row.template_type;
          }
        }
      }, {
        label: '模板Id',
        prop: 'template_id'
      }, {
        label: '模板名称',
        prop: 'template_name'
      }, {
        label: '皮肤名称',
        prop: 'skin_name'
      }, {
        label: '项目类型',
        prop: 'project_type',
        params: {
          innerHTML: function innerHTML(_ref6) {
            var row = _ref6.row;

            return useValueExchangeLabel(row.project_type, playableProjectTypeOptions) || row.project_type;
          }
        }
      }, {
        label: '项目id',
        prop: 'project_id'
      }, {
        label: '项目名称',
        prop: 'project_name'
      }, {
        label: '项目制作时长',
        prop: 'production_duration',
        params: {
          innerHTML: function innerHTML(_ref7) {
            var row = _ref7.row;

            return formatTimeWithoutMs(row.production_duration);
          }
        }
      }, {
        label: '是否使用玩法场景',
        prop: 'use_play_scene',
        params: {
          innerHTML: function innerHTML(_ref8) {
            var row = _ref8.row;

            return row.use_play_scene ? '是' : '否';
          }
        }
      }, {
        label: '是否使用全局变量',
        prop: 'use_global_var',
        params: {
          innerHTML: function innerHTML(_ref9) {
            var row = _ref9.row;

            return row.use_global_var ? '是' : '否';
          }
        }
      }, {
        label: '是否使用区域手势',
        prop: 'use_zone_hand',
        params: {
          innerHTML: function innerHTML(_ref10) {
            var row = _ref10.row;

            return row.use_zone_hand ? '是' : '否';
          }
        }
      }, {
        label: '是否使用裁剪',
        prop: 'use_crop',
        params: {
          innerHTML: function innerHTML(_ref11) {
            var row = _ref11.row;

            return row.use_crop ? '是' : '否';
          }
        }
      }, {
        label: '是否使用下载全部资源',
        prop: 'use_down_all_res',
        params: {
          innerHTML: function innerHTML(_ref12) {
            var row = _ref12.row;

            return row.use_down_all_res ? '是' : '否';
          }
        }
      }, {
        label: '是否使用复制至自由编辑',
        prop: 'use_copy_to_ps',
        params: {
          innerHTML: function innerHTML(_ref13) {
            var row = _ref13.row;

            return row.use_copy_to_ps ? '是' : '否';
          }
        }
      }, {
        label: '使用组件',
        prop: 'use_widgets',
        params: {
          innerHTML: function innerHTML(_ref14) {
            var row = _ref14.row;

            if (row.use_widgets) {
              var widgets = row.use_widgets.split(',');
              return widgets.map(function (item) {
                return useValueExchangeLabel(item, psWidgetOptions);
              }).join(',');
            }
            return '-';
          }
        }
      }];

      return tableList;
    }
  },

  watch: {
    $route: function $route(to, from) {
      if (_.isEmpty(to.query)) {
        this.query = _extends({}, defaultQuery);
      }
      this.dispatch();
    },
    'query.adv_search_type': function queryAdv_search_type(val) {
      if (val === 'adv_name') {
        this.query.adv_id = '';
      } else {
        this.query.adv_ids = [];
      }
    }
  },

  mounted: function mounted() {
    this.dispatch();
  },


  methods: {
    exportSheet: function exportSheet() {
      var params = _extends({}, this.getParamsData(this.query), {
        export: 1
      });
      downloadWithNewWindow(v2Host + '/dashboard/playturbo/playable-project-list?' + qs.stringify(_extends({}, cookRequestParams(params))));
    },
    handleSortChange: function handleSortChange(_ref15) {
      var column = _ref15.column,
          prop = _ref15.prop,
          order = _ref15.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '';
      }
      this.$router.push({
        query: this.query
      });
    },
    dispatch: function dispatch() {
      this.getMaterialReport();
    },
    getMaterialReport: function getMaterialReport(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, sum, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.listLoading = true;
                _context.prev = 1;
                _context.next = 4;
                return getPlayableProjectList(_this.getParamsData(params));

              case 4:
                res = _context.sent;
                sum = _.get(res, 'data.data.sum', []);
                list = sum.concat(_.get(res, 'data.data.list') || []);

                _this.list = list.map(function (item) {
                  return _extends({}, item, {
                    use_crop: item.use_features.indexOf('crop') > -1,
                    use_play_scene: item.use_features.indexOf('play_scene') > -1,
                    use_global_var: item.use_features.indexOf('global_var') > -1,
                    use_zone_hand: item.use_features.indexOf('zone_hand') > -1,
                    use_down_all_res: item.use_features.indexOf('down_all_res') > -1,
                    use_copy_to_ps: item.use_features.indexOf('copy_to_ps') > -1
                  });
                });
                _this.pagination.total = _.get(res, 'data.data.total') || 0;
                _this.listLoading = false;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](1);

                _this.listLoading = false;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 12]]);
      }))();
    },
    getParamsData: function getParamsData(params) {
      var innerParams = _.omit(_.cloneDeep(params || this.query), ['adv_search_type', 'adv_id']);
      if (!_.isEmpty(innerParams.push_download_time)) {
        innerParams.download_push_start_date = innerParams.push_download_time[0];
        innerParams.download_push_end_date = innerParams.push_download_time[1];
        innerParams = _.omit(innerParams, ['push_download_time']);
      }
      innerParams.adv_ids = this.query.adv_search_type === 'adv_name' ? this.query.adv_ids : [this.query.adv_id];
      return innerParams;
    },
    handleColumnFilterChange: function handleColumnFilterChange() {
      this.query.page = 1;
      this.handleSearch(this.query);
    },
    resetSearch: function resetSearch() {
      this.handleResetSearch();
    }
  }
};